var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramGroceries64(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pictogram/Medium./Groceries64*",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounding-Box",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groceries64*",
    transform: "translate(16.000000, 8.000000)",
    stroke: "#4F4C4D",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Milk",
    transform: "translate(3.000000, 0.000000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    points: "0 12 3 4 10 4 13 11 13 21 0 21"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Top",
    x: 1,
    y: 0,
    width: 11,
    height: 4,
    rx: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Apple",
    transform: "translate(11.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.21503795,19.593195 C3.2008049,18.4702453 1.24026437,15.5410953 0.698303718,11.7773508 C0.312303523,9.09670215 1.30449712,5.97205953 3.32393181,4.45411788 C4.17343457,3.81557502 5.40463899,3.40075286 6.66512818,3.72048582 C7.48976038,3.92966024 8.32692642,4.8494974 9.07794833,4.8494974 C9.94438881,4.8494974 10.9038089,3.91902642 11.8332211,3.73482102 C13.112107,3.48135148 14.3341755,4.02192782 15.1789984,4.72957568 C16.9995956,6.25456011 17.8210415,9.25331626 17.4575929,11.7773508 C16.9122467,15.5646075 14.9305413,18.5068097 11.8842455,19.6140286 C10.0235165,19.8252613 10.2754979,19.109329 9.07794833,19.109329 C7.87349399,19.109329 8.14029198,19.8433929 6.21503795,19.593195 Z",
    id: "Combined-Shape",
    fill: "#FFCC00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,0 C10.1075313,0 9,1.13038915 9,4",
    id: "Oval-Copy",
    strokeLinecap: "square"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#FFFFFF",
    points: "14.6585213 20.5906906 16.0776367 22 17.4778168 20.5809383 20.0244141 18 24.0266113 22 28.0922852 18 31.9382324 22 32 48 0 48 0 22 4 18 7.99560547 22 12.0498047 18"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramGroceries64);
export default __webpack_public_path__ + "static/media/pictogramGroceries64.fdb2694da0dc50402432075d789b3c9f.svg";
export { ForwardRef as ReactComponent };